import { render, staticRenderFns } from "./otpCascader.vue?vue&type=template&id=511820b4&"
import script from "./otpCascader.vue?vue&type=script&lang=js&"
export * from "./otpCascader.vue?vue&type=script&lang=js&"
import style0 from "./otpCascader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports